// extracted by mini-css-extract-plugin
export default {"root":"classes_root__AJiAl","description":"classes_description__x7n1h","lang":"classes_lang__bce0U","select":"classes_select__tBP3K"};